import { Box } from '@mui/material';

import HeaderStats from '@/components/ui/header/headerStats/v1/HeaderStats';

export const HEADER_HEIGHT = 64;
export const HEADER_STATS_BAR_HEIGHT = 36;

/**
 * Secondary bar rendered below the main Header, showing the BTC price / sales / wallet
 * balance ticker. Kept as its own fixed, full-width row (instead of living inside the
 * 64px Header row or being absolutely positioned over it) so it never collides with the
 * mobile nav Drawer or the Sidebar, both of which assume the Header is exactly 64px tall.
 * Its z-index sits between the Sidebar's (1000) and the mobile nav Drawer's Modal (1300),
 * so the mobile nav cleanly covers it while open instead of visually corrupting it.
 */
const HeaderStatsBar = () => (
  <Box
    sx={(theme) => ({
      top: HEADER_HEIGHT,
      left: 0,
      right: 0,
      position: 'fixed',
      zIndex: 1150,
      minHeight: HEADER_STATS_BAR_HEIGHT,
      display: 'flex',
      alignItems: 'center',
      justifyContent: { xs: 'center', md: 'flex-start' },
      px: { xs: 1, md: 3 },
      py: 0.5,
      backgroundColor: theme.palette.branding?.red,
      borderTop: '1px solid rgba(255, 255, 255, 0.15)',
    })}
    data-test="header-stats-bar"
  >
    <HeaderStats />
  </Box>
);

export default HeaderStatsBar;
